import {
  getOptions,
  getSelectedOptions,
  MultiSelect,
  type MultiSelectOption,
  type MultiSelectProps,
  type OnChangeRequest,
} from '@piccolohealth/ui';
import React from 'react';
import { useController } from 'react-hook-form';

interface Props<A> extends Omit<MultiSelectProps<A>, 'onChange' | 'selectedValues'> {
  name: string;
  capitalizeLabels?: boolean;
}

export const HookedMultiSelect = <A,>(props: React.PropsWithChildren<Props<A>>) => {
  const { name, options, capitalizeLabels, ...rest } = props;
  const { field } = useController({ name });
  const { onChange, value } = field;

  const onChangePrime = React.useCallback(
    (req: OnChangeRequest<A>) => onChange(req.values.map((v) => v.value)),
    [onChange],
  );

  const flatOptions = React.useMemo(() => getOptions(options), [options]);

  const selectedValues: MultiSelectOption<A>[] = React.useMemo(() => {
    return getSelectedOptions(flatOptions, value, capitalizeLabels);
  }, [flatOptions, value, capitalizeLabels]);

  return (
    <MultiSelect
      {...rest}
      options={options}
      onChange={onChangePrime}
      selectedValues={selectedValues}
    />
  );
};
